import React from "react";
import { SvgIcon } from "@material-ui/core";

export const WeizenIcon = (props) => (
  <SvgIcon
    viewBox="0 0 820.000000 1280.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <metadata>Quelle: https://svgsilh.com/de/ff9800/image/161629.html</metadata>
    <g
      transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path
        d="M6495 12768 c-78 -92 -255 -519 -355 -852 -131 -440 -200 -846 -219
-1283 -26 -596 69 -1078 270 -1369 67 -97 144 -165 238 -212 66 -33 84 -37
150 -37 65 0 83 4 123 27 85 51 149 144 185 269 15 54 18 101 17 304 -2 497
-51 621 -409 1030 -144 165 -246 298 -282 368 -46 92 -43 313 8 622 29 181 72
336 161 585 116 324 158 457 165 523 7 68 -9 76 -52 25z"
      />
      <path
        d="M4391 12222 c-38 -140 -49 -793 -18 -1037 22 -172 21 -398 -3 -675
-25 -288 -25 -471 0 -680 25 -211 25 -419 0 -710 -25 -286 -25 -471 0 -680 25
-210 25 -414 0 -690 -25 -275 -25 -478 0 -700 25 -222 25 -428 0 -690 -26
-267 -26 -479 0 -695 25 -215 25 -390 0 -675 -24 -268 -25 -470 -5 -652 10
-90 14 -231 14 -438 -1 -396 13 -599 92 -1335 40 -370 45 -397 110 -605 149
-471 435 -1070 667 -1393 109 -153 343 -380 465 -452 56 -32 228 -78 298 -78
96 -1 163 53 206 163 25 66 25 269 -1 370 -58 228 -166 418 -353 619 -173 186
-397 350 -557 408 -23 8 -77 20 -122 28 -104 17 -155 43 -230 120 -304 310
-457 891 -509 1930 l-5 110 54 -210 c84 -330 164 -557 303 -860 263 -577 639
-1073 918 -1213 112 -56 160 -67 285 -67 144 0 182 15 214 84 19 41 21 63 20
201 -1 134 -4 169 -27 255 -48 181 -159 378 -327 577 -133 160 -264 259 -475
362 -116 56 -210 90 -285 102 -39 6 -55 17 -120 83 -42 42 -103 117 -135 166
-123 187 -280 531 -329 722 -33 127 -77 613 -92 1004 -7 193 0 249 22 169 7
-25 44 -164 83 -310 118 -446 202 -677 352 -980 146 -294 305 -528 491 -725
231 -244 427 -345 645 -332 156 9 195 53 201 225 8 191 -33 358 -134 551 -81
156 -174 281 -309 416 -192 192 -371 304 -584 365 -178 51 -196 67 -341 300
-295 475 -374 742 -410 1375 -12 215 -21 553 -15 540 2 -5 30 -95 60 -200 267
-912 423 -1266 734 -1668 214 -276 383 -423 561 -487 55 -20 85 -24 190 -24
107 -1 131 2 165 20 68 35 80 72 80 249 -1 171 -17 249 -84 405 -85 198 -196
356 -366 525 -179 178 -364 290 -582 353 -177 51 -199 72 -391 366 -151 229
-209 357 -257 561 -64 275 -96 592 -109 1105 l-6 195 21 -70 c11 -38 50 -176
86 -305 126 -451 223 -720 363 -1005 193 -391 513 -786 750 -925 112 -66 175
-83 340 -87 179 -5 187 -2 217 87 54 159 15 447 -89 655 -193 383 -572 705
-948 807 -41 11 -93 32 -114 46 -83 56 -287 333 -384 520 -105 202 -175 510
-211 927 -11 123 -32 600 -30 690 l1 50 19 -70 c222 -792 287 -979 456 -1315
131 -261 259 -452 436 -652 163 -183 303 -298 447 -367 195 -95 344 -71 412
66 21 44 23 61 23 193 0 129 -3 156 -29 245 -37 133 -130 319 -213 430 -87
116 -252 286 -367 380 -178 144 -333 226 -462 244 -39 6 -79 19 -97 32 -51 35
-122 123 -228 282 -286 427 -372 787 -395 1646 -4 166 -3 243 4 236 11 -11 35
-93 117 -400 180 -671 394 -1130 716 -1537 219 -275 465 -456 665 -489 60 -10
79 -9 127 5 122 35 169 119 168 295 -1 128 -13 196 -57 331 -67 203 -183 378
-384 581 -238 241 -455 378 -643 409 -76 12 -121 43 -204 140 -150 175 -283
410 -351 622 -102 313 -146 631 -162 1158 -9 318 -16 406 -31 416 -4 2 -13
-13 -18 -34z"
      />
      <path
        d="M7230 12171 c-16 -30 -13 -49 36 -270 58 -262 73 -373 81 -596 12
-347 -28 -668 -144 -1158 -63 -266 -64 -257 17 -257 74 0 101 30 157 179 70
185 158 741 170 1061 7 224 -4 300 -138 930 -12 58 -26 111 -32 118 -6 7 -34
12 -73 12 -52 0 -65 -3 -74 -19z"
      />
      <path
        d="M5281 12072 c-19 -14 -32 -66 -86 -336 -98 -487 -100 -499 -100 -756
0 -164 5 -259 18 -349 31 -211 66 -374 85 -401 24 -31 69 -43 129 -33 60 10
62 18 34 192 -56 352 -78 686 -61 934 14 212 36 326 100 530 27 87 50 167 50
178 0 10 -9 28 -20 39 -27 27 -118 28 -149 2z"
      />
      <path
        d="M8151 11165 c-6 -25 -21 -143 -32 -263 -51 -548 -94 -687 -399 -1297
l-175 -350 -106 -16 c-135 -21 -194 -39 -299 -89 -295 -143 -582 -422 -723
-705 -77 -153 -89 -206 -95 -397 -7 -261 8 -321 91 -361 82 -41 291 -16 420
50 259 130 559 517 883 1138 224 431 360 887 429 1445 46 372 61 890 25 890
-4 0 -13 -20 -19 -45z"
      />
      <path
        d="M11496 10002 c-12 -20 -34 -234 -51 -487 -48 -752 -225 -1237 -500
-1370 -27 -13 -81 -29 -119 -35 -126 -20 -276 -95 -431 -215 -176 -137 -314
-358 -360 -576 -31 -145 -16 -261 42 -329 54 -63 104 -84 194 -85 69 0 83 4
160 42 115 58 204 127 334 258 132 133 207 236 279 382 153 309 348 837 395
1071 45 218 71 552 78 972 5 312 -1 405 -21 372z"
      />
      <path
        d="M8167 9814 c-15 -26 -29 -110 -47 -297 -31 -325 -65 -511 -135 -726
-92 -284 -278 -646 -418 -814 -46 -55 -92 -82 -160 -90 -158 -21 -432 -193
-642 -402 -225 -224 -383 -475 -441 -702 -47 -180 -19 -413 54 -461 22 -14 51
-17 172 -17 131 1 152 3 218 27 106 38 173 82 275 178 286 270 656 872 848
1380 153 404 228 745 280 1280 15 160 24 613 12 635 -6 9 -13 14 -16 9z"
      />
      <path
        d="M1094 9755 c-11 -60 3 -671 20 -872 32 -372 60 -510 158 -798 121
-356 281 -723 382 -875 136 -204 411 -449 570 -509 117 -44 251 -16 312 65 97
127 61 389 -91 648 -51 88 -206 247 -305 313 -137 92 -264 148 -366 162 -94
14 -149 45 -239 135 -112 113 -183 255 -254 507 -70 251 -99 458 -126 878 -21
322 -42 444 -61 346z"
      />
      <path
        d="M10618 9468 c-128 -69 -196 -157 -319 -413 -154 -320 -369 -967 -386
-1161 -5 -56 -3 -63 18 -78 13 -9 40 -16 60 -16 35 0 38 3 53 43 8 23 22 80
31 127 91 474 239 860 464 1213 116 181 167 277 158 301 -8 21 -13 21 -79 -16z"
      />
      <path
        d="M1830 9262 l-22 -18 30 -60 c16 -32 89 -142 162 -244 73 -102 154
-222 181 -268 156 -263 264 -542 344 -886 52 -224 50 -222 110 -210 78 14 81
49 26 267 -136 531 -447 1230 -612 1370 -71 62 -175 85 -219 49z"
      />
      <path
        d="M12063 8691 c-34 -55 -64 -153 -73 -239 -24 -226 -169 -521 -444
-905 -60 -83 -113 -162 -119 -175 -14 -31 10 -53 82 -76 68 -21 89 -10 124 66
13 29 85 159 159 288 150 261 203 363 249 477 69 173 99 302 102 435 2 83 1
88 -27 117 -35 36 -37 37 -53 12z"
      />
      <path
        d="M9530 8574 c-18 -25 -44 -73 -60 -107 -87 -192 -209 -932 -210 -1267
0 -327 99 -779 226 -1032 83 -165 164 -223 300 -216 142 7 205 86 225 283 16
152 6 509 -16 595 -38 146 -152 340 -320 540 -121 145 -164 228 -172 332 -9
118 23 468 68 751 28 178 18 208 -41 121z"
      />
      <path
        d="M515 8491 c-54 -11 -65 -71 -45 -231 30 -227 114 -430 337 -815 61
-105 129 -226 151 -270 55 -109 68 -121 128 -106 66 17 104 38 104 59 0 10
-44 81 -98 157 -191 272 -334 553 -422 829 -38 119 -60 225 -60 289 0 84 -22
104 -95 88z"
      />
      <path
        d="M8149 8409 c-6 -13 -15 -96 -20 -188 -12 -231 -32 -361 -90 -591 -75
-301 -199 -597 -369 -881 -103 -173 -132 -200 -246 -234 -250 -75 -408 -164
-610 -343 -334 -297 -508 -636 -508 -992 0 -89 3 -112 22 -152 33 -67 63 -79
214 -79 239 0 344 40 500 190 274 262 596 765 807 1258 140 328 225 682 300
1253 45 338 64 672 42 749 -9 33 -27 37 -42 10z"
      />
      <path
        d="M3024 8387 c-3 -9 5 -95 20 -189 31 -210 43 -314 56 -482 24 -316 10
-362 -181 -589 -133 -158 -252 -353 -293 -482 -47 -149 -50 -615 -5 -765 20
-66 78 -124 145 -145 49 -15 66 -16 117 -7 32 6 78 23 102 37 187 109 379 784
362 1275 -14 396 -133 1059 -223 1236 -42 85 -90 137 -100 111z"
      />
      <path
        d="M12546 7946 c-19 -19 -83 -99 -142 -178 -166 -219 -473 -518 -621
-604 -76 -45 -133 -54 -403 -64 -272 -9 -399 -27 -523 -74 -259 -97 -528 -308
-612 -479 -85 -172 -32 -295 146 -342 78 -21 169 -18 289 9 231 52 460 160
685 320 330 236 841 768 1067 1111 73 112 178 301 178 321 0 24 -28 15 -64
-20z"
      />
      <path
        d="M9113 7746 c-102 -86 -249 -699 -314 -1316 -66 -613 113 -1327 369
-1478 41 -23 58 -27 128 -27 70 0 85 3 121 27 106 70 154 221 154 482 0 316
-65 480 -357 911 -156 229 -193 328 -194 511 0 108 14 213 81 603 27 161 48
298 47 303 -2 6 -18 -2 -35 -16z"
      />
      <path
        d="M5 7750 c-11 -17 7 -64 69 -185 90 -172 204 -354 249 -395 22 -19
184 -180 361 -357 415 -415 582 -547 871 -688 223 -108 411 -159 569 -153 86
3 110 8 158 31 107 52 141 124 114 235 -33 134 -131 255 -306 379 -121 87
-313 183 -418 212 -97 27 -221 39 -492 51 -255 10 -297 19 -386 81 -173 121
-444 392 -602 601 -87 116 -161 198 -177 198 -2 0 -6 -4 -10 -10z"
      />
      <path
        d="M3460 7535 c0 -9 22 -145 50 -303 87 -499 97 -632 61 -774 -26 -102
-63 -172 -188 -357 -284 -421 -345 -579 -344 -901 1 -333 94 -504 276 -504
195 0 351 235 449 674 89 402 80 788 -35 1401 -82 443 -169 710 -248 765 -19
14 -21 13 -21 -1z"
      />
      <path
        d="M12171 7175 c-28 -31 -115 -152 -193 -268 -271 -406 -416 -578 -573
-682 -175 -116 -246 -132 -626 -144 -329 -9 -358 -15 -527 -100 -409 -205
-656 -567 -490 -717 79 -72 222 -76 476 -13 507 125 998 471 1418 999 290 364
623 925 577 971 -7 7 -27 -8 -62 -46z"
      />
      <path
        d="M8141 6990 c-6 -28 -11 -81 -11 -118 0 -204 -76 -624 -161 -890 -81
-250 -335 -717 -436 -801 -23 -19 -64 -37 -117 -51 -155 -41 -256 -86 -386
-173 -321 -213 -600 -568 -696 -882 -47 -155 -37 -409 20 -480 l24 -30 159 1
c255 1 353 36 500 177 212 204 418 516 677 1027 197 388 261 556 331 875 111
500 188 1236 144 1364 -16 46 -36 39 -48 -19z"
      />
      <path
        d="M370 6980 c0 -100 332 -639 604 -980 129 -162 400 -431 548 -545 339
-261 704 -424 1049 -467 164 -20 274 14 314 98 26 54 16 142 -23 221 -88 174
-275 337 -523 458 -170 82 -189 85 -534 95 -327 9 -354 14 -480 74 -223 105
-357 248 -673 719 -174 258 -243 347 -268 347 -8 0 -14 -9 -14 -20z"
      />
      <path
        d="M8555 6543 c-81 -194 -166 -521 -204 -788 -120 -833 50 -1639 381
-1804 138 -69 244 -22 298 132 49 139 63 357 35 521 -42 239 -183 531 -373
774 -90 113 -117 158 -141 229 -43 127 -38 262 25 638 44 266 53 385 31 385
-10 0 -28 -31 -52 -87z"
      />
      <path
        d="M3993 6323 c4 -49 22 -183 41 -299 20 -115 41 -271 48 -346 10 -118
10 -145 -5 -219 -20 -102 -59 -181 -138 -279 -184 -228 -305 -458 -375 -713
-32 -114 -43 -313 -25 -437 39 -261 133 -370 285 -326 385 112 578 1016 416
1948 -29 165 -83 373 -141 545 -79 231 -117 276 -106 126z"
      />
      <path
        d="M11565 5911 c-37 -23 -93 -82 -321 -336 -235 -262 -360 -387 -415
-413 -72 -35 -177 -52 -515 -82 -353 -32 -559 -82 -710 -171 -122 -72 -265
-239 -363 -423 -40 -77 -40 -117 1 -177 55 -81 66 -84 278 -84 257 1 364 27
605 147 403 201 908 650 1192 1058 116 167 289 468 281 490 -2 5 -16 1 -33 -9z"
      />
      <path
        d="M8161 5697 c-16 -40 -29 -136 -46 -332 -32 -361 -94 -624 -217 -925
-72 -178 -284 -567 -341 -628 -33 -35 -65 -49 -166 -71 -350 -77 -781 -433
-965 -799 -84 -166 -132 -382 -124 -547 6 -116 26 -161 86 -194 93 -51 293
-36 437 33 266 127 575 526 894 1156 193 381 300 697 377 1109 53 287 93 720
95 1011 1 184 -9 243 -30 187z"
      />
      <path
        d="M1022 5649 c10 -102 133 -303 336 -549 126 -152 445 -470 607 -604
322 -267 675 -454 923 -487 45 -6 152 -9 239 -7 182 3 194 8 244 86 40 63 38
99 -13 191 -225 413 -446 529 -1103 581 -283 22 -431 50 -497 92 -55 35 -177
159 -422 433 -312 347 -323 356 -314 264z"
      />
      <path
        d="M11188 5121 c-23 -26 -85 -111 -137 -187 -219 -322 -357 -481 -558
-641 -225 -179 -321 -211 -583 -192 -242 17 -395 -13 -608 -120 -205 -103
-386 -250 -460 -374 -41 -68 -78 -174 -87 -248 -5 -50 -3 -60 17 -83 31 -36
159 -87 234 -93 110 -10 349 41 506 106 227 95 387 223 918 730 276 264 350
330 350 314 0 -15 -213 -384 -285 -495 -37 -56 -100 -146 -139 -198 -84 -113
-322 -355 -421 -428 -102 -76 -151 -88 -448 -111 -475 -38 -662 -89 -896 -245
-210 -140 -293 -267 -308 -472 -7 -100 2 -118 73 -151 86 -39 208 -50 345 -31
145 21 237 52 424 143 393 193 783 536 1160 1020 238 305 422 622 609 1048 36
81 101 208 145 281 97 162 150 267 185 364 44 123 34 141 -36 63z"
      />
      <path
        d="M8211 4988 c-1 -15 11 -204 25 -420 15 -225 27 -493 28 -628 1 -219
-2 -249 -32 -440 -56 -355 -55 -305 -12 -509 20 -100 40 -184 43 -188 10 -9
102 25 166 62 101 59 163 149 190 275 19 86 26 343 12 456 -20 165 -54 274
-141 449 -115 234 -179 441 -235 765 -15 85 -31 166 -35 180 l-8 25 -1 -27z"
      />
      <path
        d="M1364 4906 c14 -75 109 -277 201 -425 64 -104 118 -211 180 -357 281
-658 771 -1309 1298 -1724 204 -161 476 -313 672 -378 230 -75 500 -67 591 19
20 19 24 32 24 83 0 83 -23 182 -57 253 -35 72 -142 182 -243 250 -241 162
-461 220 -945 253 -276 19 -310 29 -446 138 -181 145 -358 344 -512 579 -128
194 -308 513 -289 513 9 0 126 -109 464 -431 525 -501 708 -620 1073 -696 170
-36 243 -34 347 6 122 47 133 58 132 125 -2 72 -36 181 -80 256 -113 193 -397
389 -694 478 -81 25 -97 26 -355 27 -299 2 -312 4 -428 69 -85 47 -232 161
-336 261 -114 109 -224 246 -371 460 -140 205 -195 275 -217 275 -12 0 -14 -7
-9 -34z"
      />
      <path
        d="M8141 4278 c-5 -29 -12 -120 -15 -203 -21 -520 -121 -829 -480 -1487
-121 -222 -93 -198 -253 -218 -225 -29 -352 -99 -549 -302 -230 -238 -407
-482 -478 -661 -45 -114 -76 -331 -61 -438 13 -91 95 -170 194 -185 50 -8 168
13 252 45 268 102 543 418 873 1003 292 519 452 1019 526 1638 31 265 53 795
34 844 -13 33 -33 16 -43 -36z"
      />
      <path
        d="M4260 4045 c-99 -134 -212 -337 -236 -421 -21 -78 -31 -442 -15 -576
20 -175 65 -274 142 -313 30 -16 245 -52 254 -43 3 3 -5 99 -19 214 -39 325
-47 461 -45 704 5 393 3 438 -25 475 -12 17 -17 13 -56 -40z"
      />
      <path
        d="M8157 2926 c-10 -24 -26 -162 -42 -346 -41 -470 -121 -720 -404
-1259 -161 -306 -191 -341 -291 -341 -58 0 -170 -40 -308 -109 -278 -139 -431
-279 -625 -571 -79 -120 -119 -203 -115 -240 6 -53 19 -55 548 -58 l485 -3 37
83 c20 46 111 250 203 453 380 840 436 1009 494 1475 44 352 69 841 47 908 -8
25 -21 29 -29 8z"
      />
      <path
        d="M10043 2828 c-36 -35 -148 -155 -248 -268 -209 -236 -312 -336 -387
-380 -107 -62 -195 -77 -568 -100 -275 -17 -430 -49 -584 -119 l-61 -28 -24
-124 c-32 -169 -94 -407 -130 -502 l-30 -79 187 4 187 4 89 38 c182 81 502
279 686 426 321 258 772 762 929 1041 34 60 53 149 31 149 -6 0 -41 -28 -77
-62z"
      />
      <path
        d="M2480 2638 c1 -167 544 -817 974 -1165 165 -133 493 -337 668 -415
120 -53 206 -67 414 -68 161 0 173 1 204 23 198 133 -29 506 -444 731 -153 83
-223 98 -566 116 -513 27 -525 34 -948 513 -177 200 -240 265 -281 287 -19 10
-21 8 -21 -22z"
      />
      <path
        d="M9779 2193 c-43 -46 -83 -101 -223 -304 -205 -299 -422 -547 -585
-668 -89 -66 -138 -85 -257 -101 -112 -15 -386 -14 -475 1 -41 7 -86 9 -100 6
-13 -3 -76 -39 -138 -78 l-114 -72 -98 -201 c-109 -225 -157 -341 -235 -563
l-54 -153 44 0 c139 0 398 109 546 228 47 38 175 132 285 207 351 243 461 332
662 536 372 378 734 914 788 1167 9 42 -3 41 -46 -5z"
      />
      <path
        d="M2785 1999 c-15 -39 92 -271 218 -475 122 -196 311 -441 493 -639
198 -215 369 -357 711 -594 122 -85 252 -178 289 -207 37 -30 84 -59 103 -65
22 -7 166 -13 360 -16 l323 -5 -4 128 c-4 124 -5 132 -40 205 -29 59 -54 92
-119 153 -88 84 -325 246 -462 316 -129 65 -161 70 -462 80 -256 9 -378 22
-449 50 -91 34 -317 243 -468 430 -72 90 -115 149 -320 441 -115 163 -164 219
-173 198z"
      />
    </g>
  </SvgIcon>
);

export default WeizenIcon;
